import { useState, useContext } from "react";
import { AppContext } from "../../Context";

const Form = () => {
  const { insertUser } = useContext(AppContext);
  const [newUser, setNewUser] = useState({});

  // Storing the Insert User Form Data.
  const addNewUser = (e, field) => {
    setNewUser({
      ...newUser,
      [field]: e.target.value,
    });
  };

  // Inserting a new user into the Database.
  const submitUser = (e) => {
    e.preventDefault();
    insertUser(newUser);
    e.target.reset();
  };

  return (
    <form className="insertForm" onSubmit={submitUser}>
      <div className="row">
        <h4>Cadastro</h4>
      </div>
      
      <div className="input-field col s12">
        <input
          type="text"
          id="_name"
          name="_name"
          onChange={(e) => addNewUser(e, "nome")}
          autoComplete="off"
          required
        />
        <label htmlFor="_name">Nome</label>
      </div>
      <div className="input-field col s12">
        <input
          type="number"
          id="_telefone"
          name="_telefone"
          onChange={(e) => addNewUser(e, "login")}
          autoComplete="off"
          required
        />
        <label htmlFor="_telefone">Telefone</label>
      </div>
      <input type="submit" value="Inserir" />
    </form>
  );
};

export default Form;